/**
 * @generated SignedSource<<9e388f51c88edd9cfcab8ef090c71a9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StaffSelectPage_sheet$data = {
  readonly id: string;
  readonly thumbnail_download_url: string;
  readonly " $fragmentSpreads": FragmentRefs<"StaffSelectPageOverlay_sheet" | "StaffSelectPageTools_sheet">;
  readonly " $fragmentType": "StaffSelectPage_sheet";
};
export type StaffSelectPage_sheet$key = {
  readonly " $data"?: StaffSelectPage_sheet$data;
  readonly " $fragmentSpreads": FragmentRefs<"StaffSelectPage_sheet">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StaffSelectPage_sheet",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail_download_url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StaffSelectPageOverlay_sheet"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StaffSelectPageTools_sheet"
    }
  ],
  "type": "MusicSheet",
  "abstractKey": null
};

(node as any).hash = "5a8c65c5acb41f90e4e4ebab8e83be37";

export default node;
